import './CollectionList.css';

import React from 'react';
import Moment from 'react-moment';

import { Header, Icon, Menu, Pagination } from 'semantic-ui-react'


const CollectionsList = ({ collections, collectionsCount, onCollectionChange, onPageChange, selectedCollection }) => {

  const collectionsPerPage = 5;

  const handleOnChange = (e, data) => {
    onCollectionChange(data.value);
  }

  const handlePaginationChange = (e, data) => {
    onPageChange(data.activePage);
  }

  if (!selectedCollection) {
    return <div></div>
  }

  return (
    <div>
      <Menu vertical>
        {collections.map(collection =>

          <Menu.Item
            key={collection.pk}
            value={collection.pk}
            active={collection.pk === selectedCollection.pk}
            onClick={handleOnChange}
          >
            <Header as='h5'>{collection.name}</Header>
            {collection.pk === selectedCollection.pk && <Icon name='check' color='green' />}
          updated <Moment fromNow>{collection.updated}</Moment><br />
          sites: {collection.sites_count},
          processes: {collection.processes_count}
          </Menu.Item>

        )}
      </Menu>

      {collectionsCount > collectionsPerPage &&
        <Pagination
          size='mini'
          defaultActivePage={1}
          totalPages={Math.ceil(collectionsCount / collectionsPerPage)}
          onPageChange={handlePaginationChange}
        />

      }

      <div>
        You have uploaded {collectionsCount} collections so far.
      </div>

    </div>
  );
};

export default CollectionsList;